
export default {

    COLORS: {
        'Alta': '#F9156F',
        'Media': '#eb4e0a',
        'Baja': '#137d2f',
        'high': '#F9156F',
        'medium': '#eb4e0a',
        'low': '#137d2f',
        'HIGH': '#F9156F',
        'MEDIUM': '#eb4e0a',
        'LOW': '#137d2f',
    },

    ICONS: {
        'Alta': 'fa-thermometer-full',
        'Media': 'fa-thermometer-half',
        'Baja': 'fa-thermometer-empty',
        'high': 'fa-thermometer-full',
        'medium': 'fa-thermometer-half',
        'low': 'fa-thermometer-empty',
        'HIGH': 'fa-thermometer-full',
        'MEDIUM': 'fa-thermometer-half',
        'LOW': 'fa-thermometer-empty',
    },

    getColor: function(state) {
        return this.COLORS[state] ?? 'white';
    },

    getIcon: function(state) {
        return this.ICONS[state] ?? 'white';
    }
}
